import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { backgroundPopupColor } from "@/libs/builder/common/backgroundPopupColor";
import { responsiveImageInputs } from "@/libs/builder/common/responsiveImageInputs";
import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const provincePopupInputs = [
  ...backgroundPopupColor,
  {
    name: "logo",
    type: "object",
    required: true,
    subFields: [
      {
        name: "src",
        type: "file",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "alt",
        type: "string",
      },
    ],
    defaultValue: {
      alt: "Logo",
      src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9d1d2ffe26704533a8ad5fbf1abac751",
    },
  },
  {
    name: "paragraph",
    type: "object",
    required: true,
    subFields: [
      {
        name: "content",
        type: "richText",
        required: true,
      },
    ],
    defaultValue: {
      content:
        "Il est interdit par la loi fédérale de fournir des produits du tabac aux personnes âgées de moins de 18 ans.",
    },
  },
  {
    name: "image",
    type: "object",
    required: true,
    subFields: responsiveImageInputs,
    defaultValue: {
      alt: "Province popup image",
      title: "Province popup image",
      largeSrc:
        "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F24847fec13674857a19141d1480b9ed2",
    },
  },
  {
    name: "primaryButton",
    type: "object",
    required: true,
    subFields: [
      {
        name: "cta",
        friendlyName: "Call to action label",
        type: "string",
      },
    ],
    defaultValue: {
      cta: "Continue",
      href: "/",
    },
  },
  {
    name: "secondaryButton",
    type: "object",
    subFields: [
      {
        name: "cta",
        friendlyName: "Call to action label",
        type: "string",
      },
      {
        name: "href",
        type: "url",
        defaultValue: "/",
      },
      {
        name: "isButtonEnabled",
        type: "boolean",
      },
    ],
  },
  {
    name: "isLogoEnabled",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "isParagraphEnabled",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "isImageEnabled",
    type: "boolean",
    defaultValue: true,
  },
] as const satisfies Inputs;

export const ProvincePopupComponent: RegisteredComponent = {
  name: "Province Popup",
  component: dynamic(
    async () => withValidation(provincePopupInputs, (await import("./ProvincePopup")).ProvincePopup, "ProvincePopup"),
    { ssr: false }
  ),
  models: [getBuilderModelName("province-popup")],
  inputs: provincePopupInputs,
};
